import { Mail, MessageCircle } from "lucide-react";

const MAILTO = "mailto:cbmr71@gmail.com";
const WA_LINK = "https://wa.me/56995530858?text=Hola%20Cecilia%2C%20vi%20tu%20p%C3%A1gina%20SoytuIA%20y%20me%20gustar%C3%ADa%20saber%20m%C3%A1s";

export default function FooterSection() {
  return (
    <footer
      data-testid="site-footer"
      className="py-16 sm:py-20 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col items-center text-center space-y-6">
          {/* Logo */}
          <a
            href="#"
            data-testid="footer-logo"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_ia-concesiones-chile/artifacts/rszkrlc3_soytu_ia_logo_cyan_transparent%20%281%29.svg"
              alt="SoytuIA"
              className="block"
              style={{ height: "60px", width: "auto" }}
            />
          </a>

          {/* Tagline */}
          <p className="text-sm text-white/40">
            Asistentes de IA a tu medida
          </p>

          {/* Links */}
          <div className="flex items-center gap-6">
            <a
              href={MAILTO}
              data-testid="footer-email-link"
              className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors"
            >
              <Mail size={16} />
              Gmail
            </a>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors"
            >
              <MessageCircle size={16} />
              WhatsApp
            </a>
          </div>

          {/* Legal */}
          <p
            data-testid="footer-legal"
            className="text-xs text-white/25 pt-4"
          >
            &copy; {new Date().getFullYear()} SoytuIA. Chile.
          </p>
        </div>
      </div>
    </footer>
  );
}
